import { module } from "angular";
import logging from "./logging/module";
import routing from "./routing/module";
import tracing from "./tracing/module";
import upgrade from "./upgrade/module";

const mod = module("core", [tracing, routing, logging, upgrade]);
export default mod.name;
